<div class="red-error animated fadeInDown alert alert-danger text-center rounded-0 border-0" *ngIf="_data.redError">
    <i class="fa fa-plug fa-2x mb-2" aria-hidden="true"></i><br>
    <span class="mt-4">{{ "redError" | language }}</span>
    <br><button (click)="refresh()" class="btn btn-danger btn-sm mt-3"><i class="fa fa-refresh" aria-hidden="true"></i> {{ "refresh" | language }}</button>
</div>

<div class="red-error animated fadeInDown alert alert-danger text-center rounded-0 border-0" *ngIf="_data.timeExceed">
    <i class="fa fa-plug fa-2x mb-2" aria-hidden="true"></i><br>
    <span class="mt-4">{{ "timeExceed" | language }}</span>
    <br><button (click)="refresh()" class="btn btn-danger btn-sm mt-3"><i class="fa fa-refresh" aria-hidden="true"></i> {{ "refresh" | language }}</button>
</div>

<app-login *ngIf="!logged" (logged)="logged = $event;"></app-login>
<div *ngIf="logged" class="maindiv">
    <div class="fixed-top hdr-menu-fixed">
        <app-header></app-header>
    </div>

    <div *ngIf="!_data.deskStopped">

        <app-information></app-information>
        <app-atypes></app-atypes>

        <div class="container-fluid" *ngIf="(_data.configuration['activeSupervisor'] || _data.session['queuemode'] != 'Q') && isContainerVisible();else onlystatus">
            <div class="row">
                <div [ngClass]="(_data.configuration['showQueueInfo'] || _data.configuration['showKindInfo']) ? 'col-md-10' : 'col-md-12'">
                    <app-list></app-list>
                </div>
                <div [ngClass]="(_data.configuration['showQueueInfo'] || _data.configuration['showKindInfo']) ? 'col-md-2' : ''">
                    <app-status (websocketError)="showAlert = true" *ngIf="(_data.configuration['showQueueInfo'] || _data.configuration['showKindInfo'])"></app-status>
                </div>
            </div>
        </div>
        <ng-template #onlystatus>
            <app-status (websocketError)="showAlert = true" *ngIf="(_data.configuration['showQueueInfo'] || _data.configuration['showKindInfo'])"></app-status>
        </ng-template>
        <app-footer></app-footer>
    </div>

    <div class="container alert alert-info text-center" style="margin-top:100px;" *ngIf="_data.deskStopped">
        <i class="fa fa-pause fa-2x mb-2" aria-hidden="true"></i><br> La atención está actualmente detenida, pulse el botón "Continuar atendiendo" para reanudar la atención.<br><br>
        <app-stop-desk [inline]="true" *ngIf="_data.deskStopped"></app-stop-desk>
    </div>
</div>
